module.exports = __webpack_public_path__ + "static/media/icon_x.ea29f25d.svg";